import { FaWhatsapp } from "react-icons/fa";

type isHidden = {
  isHidden: boolean;
};

const FloatingChat: React.FC<isHidden> = ({ isHidden = false }) => {
  return (
    <div
      onClick={() =>
        window.open(
          "https://wa.me/2347025600065?text=Hello%20I%20am%20interested%20in%20your%20services"
        )
      }
      className={`bg-gradient-to-bl from-primary-500 to-primary-900 p-3 fixed bottom-10 right-10 rounded-full shadow-lg cursor-pointer z-50 ${
        isHidden ? "hidden" : "block"
      }`}
    >
      <FaWhatsapp size={32} color="white" />
    </div>
  );
};

export default FloatingChat;
